document.addEventListener('click', function(e) {
	const item = e.target.closest('.programm .filter .item[data-filter], .programm .filter .item[data-time]');
	if (!item) return;

	const wasActive = item.classList.contains('active');

	const isType = item.hasAttribute('data-filter');
	const isTime = item.hasAttribute('data-time');

	if (isType) {
		document.querySelectorAll('.programm .filter .item.active[data-filter]').forEach(function(el) {
			el.classList.remove('active');
		});
	}

	if (isTime) {
		document.querySelectorAll('.programm .filter .item.active[data-time]').forEach(function(el) {
			el.classList.remove('active');
		});
	}

	item.classList.toggle('active', !wasActive);

	const isType2 = item.hasAttribute('data-filter');
	const isTime2 = item.hasAttribute('data-time');

	if (isType2) {
		document.querySelectorAll('.programm .filter .item.active[data-filter]').forEach(function(el) {
			if (el !== item) el.classList.remove('active');
		});
	}

	if (isTime2) {
		document.querySelectorAll('.programm .filter .item.active[data-time]').forEach(function(el) {
			if (el !== item) el.classList.remove('active');
		});
	}

	const activeTypes = Array.from(document.querySelectorAll('.programm .filter .item.active[data-filter]'))
		.map(function(el) { return el.dataset.filter; });

	const activeTimes = Array.from(document.querySelectorAll('.programm .filter .item.active[data-time]'))
		.map(function(el) { return el.dataset.time; });

	const now = new Date();
	const currentMonth = now.toLocaleString('en-US', { month: 'short' });
	const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1).toLocaleString('en-US', { month: 'short' });

	const events = document.querySelectorAll('.programm .event');

	events.forEach(function(ev) {
		const typ = ev.dataset.typ;
		const month = ev.dataset.month;

		const typeOk = activeTypes.length === 0 || activeTypes.includes(typ);

		let timeOk = true;
		if (activeTimes.length > 0) {
			timeOk = activeTimes.some(function(t) {
				if (t === 'Pre') return month !== currentMonth && month !== nextMonth;
				return month === t;
			});
		}

		ev.classList.toggle('hide', !(typeOk && timeOk));
	});
});

